exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div#contact-button {\n  background-color: #c8017d;\n  width: 56px;\n  height: 56px;\n  border-radius: 50px;\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);\n  text-align: center;\n  z-index: 9;\n  cursor: pointer;\n  position: absolute;\n  right: 60px;\n  bottom: 10px;\n  color: white;\n  line-height: 50px;\n  font-size: 40px;\n  transition: all 0.2s ease-in-out;\n}\ndiv#contact-button:hover {\n  box-shadow: 0px 0px 15px 1px #777777;\n  transform: scale(1.05);\n}\ndiv#contact-button img {\n  height: 28px;\n  width: 28px;\n}", ""]);

// exports
